exports = module.exports = require("../../node_modules/.0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".group[data-v-4ba04ce0],.name[data-v-4ba04ce0],.url[data-v-4ba04ce0]{width:300px}.content[data-v-4ba04ce0]{width:100%;height:500px}.el-icon-warning[data-v-4ba04ce0]{color:#20a0ff;display:inline-block;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.26.4@css-loader?minimize!./~/.10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-4ba04ce0&scoped=true!./~/.2.2.3@less-loader!./~/.10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/data.vue
// module id = 44
// module chunks = 1